// Hook - oznaczenie sygnalu jako rozwiazany
// POST /api/ui/trader/insights/signals/{signalId}/resolve

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type { IPostResolveSignalRequest } from 'api/types/traderInsights';

export interface IPostResolveSignalVariables {
  signalId: number;
  data?: IPostResolveSignalRequest;
}

type IResponse = ICommandResponseSuccess;

const postResolveSignal = ({ signalId, data }: IPostResolveSignalVariables): Promise<IResponse> =>
  axios.post(`/trader/insights/signals/${signalId}/resolve`, data ?? {});

export const usePostResolveSignal = (
  options?: UseMutationOptions<IResponse, IError, IPostResolveSignalVariables>
) => useMutation((variables: IPostResolveSignalVariables) => postResolveSignal(variables), options);
